/**
 * Full-screen wash shown while /checkout/payment/verify is in flight —
 * blocks interaction so the user can't navigate or re-pay mid-verification.
 */
export default function PaymentProcessingOverlay() {
  return (
    <div
      className="fixed inset-0 z-[80] bg-background/90 backdrop-blur-md flex flex-col items-center justify-center gap-10 select-none"
      role="status"
      aria-live="polite"
      aria-label="Verifying payment"
    >
      {/* Spinner ring with a static lock at its centre */}
      <div className="relative w-24 h-24">
        <div className="absolute inset-0 rounded-full border-[3px] border-secondary/20 border-t-secondary animate-spin"></div>
        <div className="absolute inset-0 grid place-items-center text-secondary">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>
      </div>

      <div className="text-center space-y-3">
        <h2 className="font-heading text-2xl md:text-3xl text-primary font-normal uppercase tracking-wide">
          ORDER SYNCHRONIZATION
        </h2>
        <p className="text-[10px] font-mono font-normal text-primary/30 uppercase tracking-[0.4em]">
          CLINICAL PROCESSING ACTIVE V4.2
        </p>
      </div>
    </div>
  )
}
